import MomentUtils from '@date-io/moment';
import {
  Box,
  Button,
  makeStyles,
  MenuItem,
  Select,
  withStyles
} from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Pagination from '@material-ui/lab/Pagination';
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { roles } from 'src/app/constant/roles';
import { getVehicleLicensePlate } from 'src/features/vehicleSlice';
import {
  BaoCaoTT09PhuLuc9,
  groupID,
  resetDataSceen
} from '../../../../features/reportBgtTT09Slice';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#F5FAFF',
    color: '#0C1132',
    border: '1px solid #E5E5E8',
  },
  body: {
    fontSize: '14px',
    border: '1px solid #E5E5E8',
    color: '#0C1132',

  }
}))(TableCell);


const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: 'white'
    },

  }
}))(TableRow);

const BaoCaoPhuLuc9ControlView = () => {

  const classes = useStyles();
  const dispatch = useDispatch();
  const dataBaoCaoTT09PhuLuc9 = useSelector(
    state => state.reportTT09Slice.dataBaoCaoTT09PhuLuc9
  );
  const dataGroupID = useSelector(state => state.reportTT09Slice.dataGroupID);

  const isLoading = useSelector(state => state.reportTT09Slice.isLoading);

  const [nowPage, setNowPage] = useState({
    page: 1
  });

  const [pages, setPages] = useState(10);

  const [searchObject, setSearchObject] = useState({
    licensePlate: '',
    groupID: '',
    firstTime: moment().set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    }),
    lastTime: moment().set({
      hour: 23,
      minute: 59,
      second: 0,
      millisecond: 0
    }),
    page: 1,
    pageSize: 30
  });

    const listLicensePlate = useSelector(
      state => state.vehicleSlice.listLicensePlate
    );
  
  useEffect(() => {
    if (dataBaoCaoTT09PhuLuc9 && dataBaoCaoTT09PhuLuc9.total > 1 && nowPage.page == 1) {

      let currentSearchObject = { ...searchObject };
      var total = dataBaoCaoTT09PhuLuc9.total;

      var phanduong = Math.floor(total / currentSearchObject.pageSize);
      var phandu = total % currentSearchObject.pageSize;
      var newPages;

      if (phandu > 0) {
        newPages = phanduong + 1;
      } else {
        newPages = phanduong;
      }

      setPages(newPages);

    } else if (nowPage.page == 1) {
      setPages(0);
    }

  }, [dataBaoCaoTT09PhuLuc9]);



  const changeSearchCondition = (name, value) => {
    let currentSearchObject = { ...searchObject };
    currentSearchObject[name] = value;
    setSearchObject(currentSearchObject);
  };

  const changeDateCondition = (name, value) => {
    let currentSearchObject = { ...searchObject };
    currentSearchObject[name] = value;
    setSearchObject(currentSearchObject);
  };

  const searchFunction = () => {
    let currentSearchObject = { ...searchObject };
    let currentNowpage = { ...nowPage };
    currentNowpage.page = 1;
    setNowPage(currentNowpage);

    currentSearchObject.firstTime = currentSearchObject.firstTime
      ? moment(currentSearchObject.firstTime).unix()
      : null;
    currentSearchObject.lastTime = currentSearchObject.lastTime
      ? moment(currentSearchObject.lastTime).unix()
      : null;
    dispatch(BaoCaoTT09PhuLuc9(currentSearchObject));
  };

  const nextPage = () => {
    let currentSearchObject = { ...searchObject };
    let currentNowpage = { ...nowPage };
    currentNowpage.page = currentNowpage.page + 1;
    setNowPage(currentNowpage);
    currentSearchObject.page = currentNowpage.page;
    currentSearchObject.firstTime = currentSearchObject.firstTime
      ? moment(currentSearchObject.firstTime).unix()
      : null;
    currentSearchObject.lastTime = currentSearchObject.lastTime
      ? moment(currentSearchObject.lastTime).unix()
      : null;
    dispatch(BaoCaoTT09PhuLuc9(currentSearchObject));
  };

  const downloadFile = () => {
    let currentSearchObject = { ...searchObject };
    var urlBase = `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${localStorage.getItem('agency-id')}/tt09/phuluc17/excel?`;

    if (currentSearchObject.firstTime) {
      urlBase = urlBase + 'firstTime=' + moment(currentSearchObject.firstTime).unix();
    }
    if (currentSearchObject.lastTime) {
      urlBase = urlBase + '&lastTime=' + moment(currentSearchObject.lastTime).unix();
    }
    if (currentSearchObject.licensePlate) {
      urlBase = urlBase + '&licensePlate=' + currentSearchObject.licensePlate;
    }
    window.open(urlBase, '_blank')
  };

  const handleChange = (e, value) => {
    let currentSearchObject = { ...searchObject };
    let currentNowpage = { ...nowPage };
    currentNowpage.page = value;
    setNowPage(currentNowpage);
    currentSearchObject.page = currentNowpage.page;
    currentSearchObject.firstTime = currentSearchObject.firstTime
      ? moment(currentSearchObject.firstTime).unix()
      : null;
    currentSearchObject.lastTime = currentSearchObject.lastTime
      ? moment(currentSearchObject.lastTime).unix()
      : null;
    dispatch(BaoCaoTT09PhuLuc9(currentSearchObject));
  }

  return (
    <Box className={classes.contentContainer}>
      <div className={classes.titleHeader}>BÁO CÁO CÁC CUỐC LÁI XE TRONG TUẦN</div>
      <div className={classes.searchContainer}>
        <div className={classes.searchRow}>

          <div className={classes.searchItem}>

            <div className={classes.label}>Từ ngày</div>
            <div>
              <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment}>
                <KeyboardDateTimePicker
                  variant="inline"
                  inputVariant="outlined"
                  format="HH:mm DD/MM/YYYY"
                  onChange={e => changeDateCondition('firstTime', e)}
                  value={searchObject.firstTime}
                  classes={{
                    root: classes.dateComponent
                  }}
                  InputProps={{
                    className: classes.dateComponent
                  }}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>

          <div className={classes.searchItem}>
            <div className={classes.label}>Đến ngày</div>
            <div>
              <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment}>
                <KeyboardDateTimePicker
                  variant="inline"
                  inputVariant="outlined"
                  format="HH:mm DD/MM/YYYY"
                  onChange={e => changeDateCondition('lastTime', e)}
                  value={searchObject.lastTime}
                  classes={{
                    root: classes.dateComponent
                  }}
                  InputProps={{
                    className: classes.dateComponent
                  }}
                />

              </MuiPickersUtilsProvider>
            </div>
          </div>

          <div className={classes.btnSearch}>
            <Button
              type="button"
              variant="contained"
              className={classes.btnStyle}
              onClick={() => searchFunction()}
            >
              Tìm kiếm
            </Button>
          </div>

        </div>
        <div className={classes.searchRow}>

          <div className={classes.searchItem}>
            <div className={classes.label}>Nhóm</div>
            <div>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                variant="outlined"
                className={classes.searchComponent}
                value={searchObject.groupID}
                onChange={e => changeSearchCondition('groupID', e.target.value)}
              >
                <MenuItem value={''}></MenuItem>


                {dataGroupID &&
                  dataGroupID.length > 0 &&
                  dataGroupID.map((row, index) => {
                    return (
                      <MenuItem value={row.id}>{row.name}</MenuItem>
                    );
                  })}

              </Select>
            </div>
          </div>

          <div className={classes.searchItem}>
            <div className={classes.label}>Biển số</div>
            <div>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                variant="outlined"
                className={classes.searchComponent}
                value={searchObject.licensePlate}
                onChange={e =>
                  changeSearchCondition('licensePlate', e.target.value)
                }
              >
                {listLicensePlate &&
                  listLicensePlate.length > 0 &&
                  listLicensePlate.map((row, index) => {
                    return (
                      <MenuItem value={row} key={index}>
                        {row}
                      </MenuItem>
                    );
                  })}
              </Select>
            </div>
          </div>

        </div>

      </div>


      <div className={classes.actionHead}>
        <img
          alt="print image"
          className={classes.image}
          src="/static/images/print.svg"
        // onClick={() => downloadFile()}
        />

        <img
          alt="Excell image"
          className={classes.image}
          src="/static/images/Excel.svg"
          onClick={() => downloadFile()}
        />
      </div>
      <div className={classes.dataTable}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            // size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <TableHead>
              <TableRow>
                <StyledTableCell rowSpan={2}>TT</StyledTableCell>
                <StyledTableCell rowSpan={2} align="left">Biển số xe</StyledTableCell>
                <StyledTableCell align="left" colSpan={2} style={{ textAlign: 'center' }}>
                  Lái xe
                </StyledTableCell>
                <StyledTableCell rowSpan={2} align="left">Ngày vi phạm</StyledTableCell>

                <StyledTableCell align="left" colSpan={3} style={{ textAlign: 'center' }}>
                  Thời gian vi phạm
                </StyledTableCell>
                <StyledTableCell align="left" colSpan={2} style={{ textAlign: 'center' }}>
                  Tọa độ vi phạm
                </StyledTableCell>
                <StyledTableCell align="left" colSpan={2} style={{ textAlign: 'center' }}>
                  Địa điểm vi phạm
                </StyledTableCell>

                <StyledTableCell rowSpan={2} align="left">Ghi chú</StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell align="left">
                  Họ tên
                </StyledTableCell>
                <StyledTableCell align="left">
                  Giấy phép lái xe
                </StyledTableCell>
                <StyledTableCell align="left">
                  Bắt đầu
                </StyledTableCell>
                <StyledTableCell align="left">
                  Kết thúc
                </StyledTableCell>
                <StyledTableCell align="left">
                  Thời gian (giờ,phút,giây)
                </StyledTableCell>
                <StyledTableCell align="left">
                  Bắt đầu
                </StyledTableCell>
                <StyledTableCell align="left">
                  Kết thúc
                </StyledTableCell>
                <StyledTableCell align="left">
                  Bắt đầu
                </StyledTableCell>
                <StyledTableCell align="left">
                  Kết thúc
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataBaoCaoTT09PhuLuc9 &&
                dataBaoCaoTT09PhuLuc9.data &&
                dataBaoCaoTT09PhuLuc9.data.length > 0 &&
                dataBaoCaoTT09PhuLuc9.data.map((row, index) => {
                  return (
                    <StyledTableRow
                      hover
                      // onClick={(event) => handleClick(event, row.name)}
                      role="checkbox"
                      // aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.name}
                    // selected={isItemSelected}
                    >
                      <StyledTableCell>{index + 1}</StyledTableCell>
                      <StyledTableCell>{row.licensePlate}</StyledTableCell>
                      <StyledTableCell>{row.driverName}</StyledTableCell>
                      <StyledTableCell>{row.licenseNumber}</StyledTableCell>
                      <StyledTableCell>{row.date}</StyledTableCell>

                      <StyledTableCell>{row.startAt ? moment.unix(row.startAt).format('HH:mm:ss DD/MM/YYYY'): ''}</StyledTableCell>
                      <StyledTableCell>{row.endAt ? moment.unix(row.endAt).format('HH:mm:ss DD/MM/YYYY'): ''}</StyledTableCell>
                      <StyledTableCell>{row.duration}</StyledTableCell>

                      <StyledTableCell>{row.startCoord[0]} , {row.startCoord[1]}</StyledTableCell>
                      <StyledTableCell>{row.endCoord[0]} , {row.endCoord[1]}</StyledTableCell>
                      <StyledTableCell>{row.startAddr}</StyledTableCell>
                      <StyledTableCell>{row.endAddr}</StyledTableCell>

                      <StyledTableCell>{row.note}</StyledTableCell>
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>

        {!dataBaoCaoTT09PhuLuc9 || !dataBaoCaoTT09PhuLuc9.data || dataBaoCaoTT09PhuLuc9.data.length < 1 ?
          <div className={classes.bottomTableError}>
            Không có dữ liệu
          </div> :
          null
        }

        <Backdrop className={classes.backdrop} open={isLoading} >
          <CircularProgress color="inherit" />
        </Backdrop>

        <Pagination onChange={handleChange} className={classes.pagination} count={pages} page={nowPage.page} variant="outlined" shape="rounded" />

        {/* <div className={classes.pagination}>
          <Button
            type="button"
            variant="contained"
            className={classes.btnStyle}
            onClick={() => nextPage()}
          >
            Tiếp theo
          </Button>
        </div> */}

      </div>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    backgroundColor: 'white',
    flexDirection: 'column',

  },
  titleHeader: {
    width: '100%',
    height: '36px',
    color: '#0C1132',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '20px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginTop: '16px',
    fontSize: "20px",

  },
  searchContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '24px',
    // marginTop: '24px',
    // marginBottom: '24px'

  },
  searchRow: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '12px',
    //justifyContent: 'space-between',
    marginRight: '48px',

  },
  searchItem: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '122px',

  },
  label: {
    marginRight: '20px',
    marginBottom: '4px',
    fontSize: '14px',
    color: '#858C93',

  },
  searchComponent: {
    // marginRight: '6px',
    width: '300px',
    height: '30px',
    '& .MuiOutlinedInput-root': {
      height: '30px'
    },

  },
  timeComponent: {
    marginRight: '4px',
    '& .MuiOutlinedInput-root': {
      height: '30px',
      width: '80px'
    },

  },
  dateComponent: {
    // marginRight: '4px',
    '& .MuiOutlinedInput-root': {
      height: '30px',
      width: '300px'
    },

  },
  btnSearch: {
    width: '180px',
    height: '40px',
    marginLeft: 'auto',

  },
  btnDownload: {
    width: '100px',
    marginLeft: 'auto',

  },
  dataTable: {
    width: '100%',
    marginLeft: '20px',
    marginBottom: '30px',

  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexWrap: 'wrap',

  },
  wrapMenu: {
    marginTop: '30px',
    marginRight: '100px',
    marginLeft: '30px',

  },
  title: {
    color: '#3f51b5',
    cursor: 'pointer',

  },
  menuItem: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,

  },
  item: {
    paddingTop: '30px',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: '500',

    '&:hover': {
      color: '#3f51b5',
      borderBottom: '1px solid #3f51b5',
      width: 'max-content'
    },

  },
  table: {
    minWidth: 700
  },
  btnStyle: {
    padding: '10px',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    marginTop: '20px',
    width: '180px',
    height: '40px',

  },

  btnDownloadStyle: {
    padding: '5px',
    color: 'white',
    backgroundColor: 'blue',
    marginTop: '10px',

  },
  pagination: {
    width: '95%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '64px',
    marginTop: '10px',

  },
  actionHead: {
    width: '100%',
    height: '24px',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '30px',
    backgroundColor: 'white',
    marginBottom: '5px',

  },
  bottomTableError: {
    width: '100%',
    height: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.main,
    marginTop: '10px',

  },
  image: {
    marginRight: '10px'
  }
}));

export default BaoCaoPhuLuc9ControlView;
